// components/canvas-toolbar/ToolbarButton.tsx
import { Button } from '@/components/ui/button'

interface ToolbarButtonProps extends React.ComponentProps<'button'> {
  active?: boolean
}

export function ToolbarButton({ active, onClick, children, className, ...props }: ToolbarButtonProps) {
  return (
    <Button
      onClick={onClick}
      variant={active ? 'default' : 'ghost'}
      size='icon-sm'
      className={className}
      {...props}
    >
      {children}
    </Button>
  )
}
